/*
 *
 * Appointments
 *
 */

import "../styles.scss";
import "moment/locale/pt";

import { API, Endpoints } from "utils/api";
import { AppointmentCard, Icons, SimpleAppointmentCard } from "components";
import { Col, ConfigProvider, DatePicker, Drawer, Row, Select, notification } from "antd";
import { setBreadcrumb, setLoader, setRoom, setUnreadChatMessages, setVideoSettings } from "store/actions";

import Animation from "assets/images/lottie/calendar.json";
import { Footer } from "screens";
import { Helmet } from "react-helmet";
import React from "react";
import Strings from "utils/strings";
import { connect } from "react-redux";
import en from "antd/es/locale/en_GB";
import lottie from "lottie-web";
import moment from "moment";
import pt from "antd/es/locale/pt_PT";

const { RangePicker } = DatePicker;

export class Appointments extends React.Component<any, any> {
	ref: any;

	constructor(props: any) {
		super(props);

		if (this.props.language === "pt") {
			moment.updateLocale("pt", {
				week: {
					dow: 1 /// Date offset
				}
			});
		} else {
			moment.updateLocale("en", {
				week: {
					dow: 1 /// Date offset
				}
			});
		}

		this.state = {
			appointments: [],
			pastAppointments: [],
			monthList: [
				moment.utc().format("MM YYYY"),
				moment.utc().add(1, "month").format("MM YYYY"),
				moment.utc().add(2, "month").format("MM YYYY"),
				moment.utc().add(3, "month").format("MM YYYY"),
				moment.utc().add(4, "month").format("MM YYYY"),
				moment.utc().add(5, "month").format("MM YYYY"),
				moment.utc().add(6, "month").format("MM YYYY")
			],
			selectedMonth: moment.utc().format("MM YYYY"),
			showFilters: true,
			filters: {
				startDate: moment.utc().add(-7, "days"),
				endDate: moment.utc()
			},
			showDrawer: false,
			selection: [],
			slots: [],
			finalSlots: []
		};
	}

	async componentDidMount() {
		const { dispatch } = this.props;
		dispatch(
			setBreadcrumb(() => ({
				locations: [
					{
						text: Strings.appointments.header,
						route: "/appointments"
					}
				]
			}))
		);

		dispatch(setLoader(true));

		await Promise.all([this.getData(), this.getSlots(), this.getHistory()]);

		dispatch(setLoader(false));
	}

	async getData() {
		const { dispatch } = this.props;

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriUsersAppointments()
			});

			if (response.ok) {
				const { nextConsultations = [], user } = response.data.results;
				this.setState({ appointments: nextConsultations });

				dispatch(setUnreadChatMessages(user?.unreadChats || false));

				if (!nextConsultations.length) {
					this.loadAnimation();
				} else {
					lottie.destroy();
				}
			} else {
				notification.error({
					message: Strings.appointments.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	componentDidUpdate(prevProps: any) {
		if (this.props.language === "pt") {
			moment.updateLocale("pt", {
				week: {
					dow: 1 /// Date offset
				}
			});
		} else {
			moment.updateLocale("en", {
				week: {
					dow: 1 /// Date offset
				}
			});
		}

		if (prevProps.language !== this.props.language) {
			this.setState({
				monthList: [
					moment.utc().format("MM YYYY"),
					moment.utc().add(1, "month").format("MM YYYY"),
					moment.utc().add(2, "month").format("MM YYYY"),
					moment.utc().add(3, "month").format("MM YYYY"),
					moment.utc().add(4, "month").format("MM YYYY"),
					moment.utc().add(5, "month").format("MM YYYY"),
					moment.utc().add(6, "month").format("MM YYYY")
				]
			});
		}
	}

	loadAnimation() {
		lottie.loadAnimation({
			container: this.ref,
			renderer: "svg",
			loop: true,
			autoplay: true,
			animationData: Animation
		});
	}

	renderHistoryDrawer() {
		const { showHistoryDrawer } = this.state;

		return (
			<Drawer
				title={<h2 className="DrawerTitle">{Strings.appointments.history}</h2>}
				footer={null}
				className="drawer AppointmentsHistoryDrawer"
				width={"100%"}
				placement="right"
				closable={true}
				visible={showHistoryDrawer}
				onClose={() => this.setState({ showHistoryDrawer: false })}
			>
				{this.renderHistoryDrawerContent()}
			</Drawer>
		);
	}

	renderHistoryDrawerContent() {
		const { filters, pastAppointments } = this.state;
		const { language } = this.props;

		return (
			<React.Fragment>
				<div className="HistoryFiltersMobile">
					<ConfigProvider locale={language === "pt" ? pt : en}>
						<RangePicker
							allowEmpty={[false, false]}
							ranges={{
								[Strings.ranges.today]: [moment(), moment()],
								[Strings.ranges.thisMonth]: [moment().startOf("month"), moment().endOf("day")],
								[Strings.ranges.lastMonth]: [
									moment().subtract(1, "month").startOf("month"),
									moment().subtract(1, "month").endOf("month")
								],
								[Strings.ranges.thisYear]: [moment().startOf("year"), moment().endOf("day")],
								[Strings.ranges.lastYear]: [
									moment().subtract(1, "year").startOf("year"),
									moment().subtract(1, "year").endOf("year")
								]
							}}
							allowClear={false}
							placeholder={[Strings.fields.startDate, Strings.fields.endDate]}
							suffixIcon={<Icons.Calendar date />}
							separator="-"
							format="DD-MM-YYYY"
							value={
								(filters?.startDate &&
									filters?.endDate && [
										moment(filters?.startDate, "DD-MM-YYYY"),
										moment(filters?.endDate, "DD-MM-YYYY")
									]) ||
								null
							}
							disabledDate={this.disabledRange}
							onChange={(value: any) => {
								this.setState(
									{
										filters: {
											startDate: value?.[0],
											endDate: value?.[1]
										}
									},
									() => this.getHistory(true)
								);
							}}
						/>
					</ConfigProvider>
				</div>
				<div className="AppointmentsList">
					{pastAppointments.map((appointment: any) => (
						<SimpleAppointmentCard
							key={`appointment_${appointment._id}`}
							simple
							appointment={appointment}
						/>
					))}
					{pastAppointments.length === 0 && <p>{Strings.appointments.noHistory}</p>}
				</div>
			</React.Fragment>
		);
	}

	renderDrawer() {
		const { showDrawer } = this.state;
		const { mobile } = this.props;

		return (
			<Drawer
				title={<h2 className="DrawerTitle">{Strings.appointments.schedule}</h2>}
				footer={
					<div className="DrawerFooter">
						<button
							className="DrawerFooterButton"
							onClick={() =>
								this.setState({
									tempAppointment: null,
									submitType: null,
									showDrawer: false
								})
							}
						>
							{Strings.appointments.cancel}
						</button>
						<button className="DrawerFooterButton --btn-primary" onClick={() => this.submitAppointment()}>
							{Strings.appointments.confirm}
						</button>
					</div>
				}
				className="drawer"
				width={mobile ? "100%" : 400}
				placement="right"
				closable={true}
				visible={showDrawer}
				onClose={() => this.setState({ showDrawer: false })}
			>
				{this.renderDrawerContent()}
			</Drawer>
		);
	}

	disabledDate = (current: any) => {
		const { selection } = this.state;
		const available = selection.some(
			(entry: any) =>
				current.year() === entry.year && current.month() === entry.month && entry.days.includes(current.date())
		);

		return !available;
	};

	disabledRange = (current: any) => {
		return moment.utc().isBefore(current);
	};

	disabledMonth = (current: any) => {
		return current.month() < moment.utc().month() || current.year() > moment.utc().year();
	};

	async getSlots(loader: boolean = false) {
		const { selectedMonth } = this.state;
		const { dispatch } = this.props;

		const body: any = {
			endDate: moment.utc(selectedMonth, "MM YYYY").endOf("month").format("YYYY-MM-DD")
		};

		if (moment.utc().month() === moment.utc(selectedMonth, "MM YYYY").month()) {
			body.startDate = moment.utc().format("YYYY-MM-DD");
		} else {
			body.startDate = moment.utc(selectedMonth, "MM YYYY").startOf("month").format("YYYY-MM-DD");
		}

		if (loader) {
			dispatch(setLoader(true));
		}

		let response: any;
		try {
			response = await API.post({
				url: Endpoints.uriSlots(),
				data: body
			});

			if (response.ok) {
				const { slots = [] } = response.data.results;

				const selection: Array<any> = [
					{
						month: moment.utc(selectedMonth, "MM YYYY").month(),
						year: moment.utc(selectedMonth, "MM YYYY").year(),
						days: []
					}
				];

				for (const slot of slots) {
					const newSelection = selection[0].days;
					const day = moment.utc(slot.date).date();
					if (!newSelection.includes(day)) {
						newSelection.push(day);
					}
				}

				let selectedDate: any;
				let finalSlots: Array<any> = [];
				if (slots.length) {
					selectedDate = moment.utc(slots[0].date);
					finalSlots = slots[0].slots || [];
				}

				this.setState({ selection, slots, selectedDate, finalSlots });
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		if (loader) {
			dispatch(setLoader(false));
		}
	}

	async getHistory(loader: boolean = false) {
		const { filters } = this.state;
		const { dispatch } = this.props;

		if (loader) {
			dispatch(setLoader(true));
		}

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriUsersLastAppointments(
					moment(filters.startDate).format("YYYY-MM-DD"),
					moment(filters.endDate).format("YYYY-MM-DD")
				)
			});

			if (response.ok) {
				const { pastConsultations: pastAppointments = [] } = response.data.results;
				this.setState({ pastAppointments });
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		if (loader) {
			dispatch(setLoader(false));
		}
	}

	async submitAppointment() {
		const { submitType, selectedDate, selectedSlot } = this.state;
		const { dispatch, user } = this.props;

		if (!selectedDate || !selectedSlot) return;

		dispatch(setLoader(true));

		let response: any;
		try {
			const body = {
				date: moment.utc(selectedDate).format("YYYY-MM-DD"),
				time: selectedSlot,
				user: user._id
			};

			const request = submitType?.type === "edit" ? API.patch : API.post;
			response = await request({
				url: Endpoints.uriAppointments(submitType?.type === "edit" ? `${submitType._id}/reschedule` : ""),
				data: body
			});

			if (response.ok) {
				this.setState({ showDrawer: false });

				await Promise.all([this.getSlots(), this.getData()]);

				notification.success({
					message: Strings.appointments.header,
					description:
						submitType?.type === "edit" ? Strings.appointments.rescheduled : Strings.appointments.created,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.appointments.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	async cancelAppointment(id: string) {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.patch({
				url: Endpoints.uriAppointments(`${id}/cancel`),
				data: {}
			});

			if (response.ok) {
				await Promise.all([this.getSlots(), this.getData()]);

				notification.success({
					message: Strings.appointments.header,
					description: Strings.appointments.cancelled,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: Strings.appointments.header,
					description: response?.data?.message || Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.appointments.header,
				description: response?.data?.message || Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	startVideoCall = async (id: any, user?: any) => {
		const { dispatch, room, audioRoom } = this.props;

		if (room || audioRoom) {
			return notification.warn({
				message: Strings.home.pendingCalls,
				description: Strings.home.cantAcceptCall,
				placement: "bottomRight",
				duration: 5
			});
		}

		const response = await API.get({
			url: Endpoints.uriVideoCalls(`consultation/${id}`)
		});

		if (response.ok) {
			const { twilioRoom, userToken } = response.data.results;

			this.setState(
				{
					activeRoom: twilioRoom.roomSid,
					roomName: twilioRoom.uniqueName,
					room: twilioRoom,
					roomState: "disconnected",
					roomNameErr: false,
					previewTracks: null,
					token: userToken,
					localMediaAvailable: true,
					hasJoinedRoom: true,
					openVideoCallModal: true
				},
				() => {
					const room = { ...twilioRoom, user };
					dispatch(setRoom(room));
					dispatch(setVideoSettings({ token: userToken, activeVideo: true, room, appointmentId: id }));
				}
			);
		} else {
			this.setState({ roomNameErr: true });

			return notification.error({
				message: Strings.serverErrors.title,
				description: Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	};

	renderDrawerContent() {
		const { monthList, slots, selectedSlot, selectedDate, selectedMonth, selection, finalSlots } = this.state;
		const { language } = this.props;

		return (
			<div className="AppointmentsDrawer">
				<Row gutter={[10, 30]}>
					<Col xs={12}>
						<label htmlFor="drawer_month" className="InputLabel --label-required">
							{Strings.appointments.selectMonth}
						</label>
						<Select
							id="drawer_month"
							className="AppointmentsFullWidth"
							placeholder={Strings.appointments.selectMonth}
							showSearch
							allowClear={false}
							filterOption={(input: any, option: any) =>
								option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
							}
							value={selectedMonth || null}
							onChange={(selectedMonth: any) =>
								this.setState({ selectedMonth }, () => this.getSlots(true))
							}
						>
							{monthList.map((month: string) => {
								let finalMonth = moment.utc(month, "MM YYYY").format("MMMM YYYY");

								return (
									<Select.Option key={`month_${month}`} value={month}>
										{`${finalMonth.substring(0, 1).toUpperCase()}${finalMonth.substring(1)}`}
									</Select.Option>
								);
							})}
						</Select>
					</Col>
					<Col xs={12}>
						<label htmlFor="drawer_day" className="InputLabel --label-required">
							{Strings.appointments.selectDate}
						</label>
						<ConfigProvider locale={language === "pt" ? pt : en}>
							<DatePicker
								id="drawer_day"
								dropdownClassName="AppointmentsDatePicker"
								className="AppointmentsFullWidth"
								disabledDate={this.disabledDate}
								disabled={!selection.length}
								suffixIcon={<Icons.Calendar date color="blue" />}
								monthCellRender={(currentDate: any) => {
									return currentDate.format("MMM");
								}}
								allowClear={false}
								format="DD-MM-YYYY"
								value={selectedDate || null}
								onChange={(value: any) => {
									const slot = slots.find(
										(tmpSlot: any) => moment.utc(tmpSlot.date).date() === value.date()
									);
									this.setState({ selectedDate: value, finalSlots: slot.slots });
								}}
							/>
						</ConfigProvider>
					</Col>
					<Col xs={24}>
						<label htmlFor="drawer_slots" className="InputLabel --label-required">
							{Strings.appointments.availableSlots}
						</label>
						<div className="DrawerSlots">
							{finalSlots.map((slot: number, index: number) => {
								return (
									<button
										key={`slot_${slot}_${index}`}
										className={`DrawerSlot${selectedSlot === slot ? " --slot-selected" : ""}`}
										onClick={() =>
											this.setState({
												selectedSlot: slot
											})
										}
									>
										<p>{slot}</p>
									</button>
								);
							})}
							{finalSlots.length === 0 && <p>{Strings.appointments.noSlots}</p>}
						</div>
					</Col>
				</Row>
			</div>
		);
	}

	render() {
		const { appointments, pastAppointments, showFilters, filters } = this.state;
		const { language, mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.sidebar.appointments} | Team24</title>
					<meta name="description" content="Description of Appointments" />
				</Helmet>
				<div className="AppointmentsContent">
					<div className="AppointmentsMainWrapper">
						{appointments.length > 0 && (
							<React.Fragment>
								<h1 className="GenericTitle">{Strings.appointments.header}</h1>
								{mobile && (
									<div className="AppointmentsHistory">
										<button onClick={() => this.setState({ showHistoryDrawer: true })}>
											<p>{Strings.appointments.history}</p>
											<Icons.Filters />
										</button>
									</div>
								)}
								<div className="CardsWrapper">
									<div className="AppointmentsDivisions">
										<div className="AppointmentsDivision">
											<h2>{Strings.home.nextAppointment}</h2>
											<AppointmentCard
												appointment={appointments[0]}
												onReschedule={() =>
													this.setState({
														showDrawer: true,
														submitType: {
															type: "edit",
															_id: appointments[0]._id
														}
													})
												}
												onCancel={() => this.cancelAppointment(appointments[0]._id)}
												onClick={async () => {
													this.startVideoCall(
														appointments[0]._id,
														appointments[0].psychologist
													);
												}}
											/>
										</div>
										<div className="AppointmentsDivision">
											<h2>{Strings.home.scheduledAppointments}</h2>
											{appointments.slice(1).map((appointment: any) => (
												<AppointmentCard
													key={`appointment_${appointment._id}`}
													noButton
													appointment={appointment}
													onReschedule={() =>
														this.setState({
															showDrawer: true,
															submitType: {
																type: "edit",
																_id: appointment._id
															}
														})
													}
													onCancel={() => this.cancelAppointment(appointment._id)}
													onClick={async () => {
														this.startVideoCall(appointment._id, appointment.psychologist);
													}}
												/>
											))}
											{appointments.slice(1).length === 0 && (
												<p>
													{appointments.length === 1
														? Strings.appointments.noMoreAppointments
														: Strings.home.noAppointments}
													.
												</p>
											)}
										</div>
									</div>
								</div>
								<div className="ScheduleButton">
									<button
										onClick={() =>
											this.setState({
												showDrawer: true,
												tempAppointment: null
											})
										}
									>
										<Icons.Calendar />
										<p>{Strings.appointments.schedule}</p>
									</button>
								</div>
							</React.Fragment>
						)}
						{appointments.length === 0 && (
							<React.Fragment>
								<div className="GenericTitle">
									<p>{Strings.appointments.header}</p>
								</div>
								<div className="EmptySchedule">
									<div
										ref={(ref: any) => {
											this.ref = ref;
										}}
									/>
									<p>{Strings.appointments.noAppointments}</p>
									<div className="EmptyScheduleButton">
										<button
											onClick={() =>
												this.setState({
													showDrawer: true
												})
											}
										>
											<Icons.Calendar />
											<p>{Strings.appointments.schedule}</p>
										</button>
									</div>
								</div>
							</React.Fragment>
						)}
					</div>
					<div className="HistoryAppointmentsWrapper">
						<div className="MultiOptionTitle">
							<h2>{Strings.appointments.history}</h2>
							<button
								onClick={() =>
									this.setState((prevState: any) => ({ showFilters: !prevState.showFilters }))
								}
							>
								<Icons.Filters />
							</button>
						</div>
						<div className={`HistoryFilters${showFilters ? " --filters-show" : ""}`}>
							<ConfigProvider locale={language === "pt" ? pt : en}>
								<RangePicker
									allowEmpty={[false, false]}
									ranges={{
										[Strings.ranges.today]: [moment(), moment()],
										[Strings.ranges.thisMonth]: [moment().startOf("month"), moment().endOf("day")],
										[Strings.ranges.lastMonth]: [
											moment().subtract(1, "month").startOf("month"),
											moment().subtract(1, "month").endOf("month")
										],
										[Strings.ranges.thisYear]: [moment().startOf("year"), moment().endOf("day")],
										[Strings.ranges.lastYear]: [
											moment().subtract(1, "year").startOf("year"),
											moment().subtract(1, "year").endOf("year")
										]
									}}
									allowClear={false}
									placeholder={[Strings.fields.startDate, Strings.fields.endDate]}
									suffixIcon={<Icons.Calendar date />}
									separator="-"
									format="DD-MM-YYYY"
									value={
										(filters?.startDate &&
											filters?.endDate && [
												moment(filters?.startDate, "DD-MM-YYYY"),
												moment(filters?.endDate, "DD-MM-YYYY")
											]) ||
										null
									}
									disabledDate={this.disabledRange}
									onChange={(value: any) => {
										this.setState(
											{
												filters: {
													startDate: value?.[0],
													endDate: value?.[1]
												}
											},
											() => this.getHistory(true)
										);
									}}
								/>
							</ConfigProvider>
						</div>
						<div className="AppointmentsList">
							{pastAppointments.map((appointment: any) => (
								<SimpleAppointmentCard
									key={`appointment_${appointment._id}`}
									simple
									appointment={appointment}
								/>
							))}
							{pastAppointments.length === 0 && <p>{Strings.appointments.noHistory}</p>}
						</div>
					</div>
					{mobile && <Footer />}
				</div>
				{this.renderDrawer()}
				{this.renderHistoryDrawer()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	language: state.language,
	user: state.user,
	mobile: state.mobile,
	room: state.room,
	audioRoom: state.audioRoom
});

export default connect(mapStateToProps)(Appointments);
